module.exports = __webpack_public_path__ + "static/t1-13f97bf9b19ec838f28e430e790fe67b.svg";